import React from 'react'
import ReactDOM from 'react-dom';import 'firebase/auth'
import {
  BrowserRouter
} from 'react-router-dom'
import * as firebase from 'firebase/app'
import 'bootstrap/dist/css/bootstrap.css'
import './index.css'
import './App.css'
import App from './App'
import * as serviceWorker from './serviceWorker'

global.jQuery = require('jquery')
require('bootstrap')

var config = {
    apiKey: "AIzaSyBxxzbzjrKvHc3a9TW974mf2-l97WrFZsY",
    authDomain: "pacientesapp.firebaseapp.com",
    databaseURL: "https://pacientesapp.firebaseio.com",
    projectId: "pacientesapp",
    storageBucket: "pacientesapp.appspot.com",
    messagingSenderId: "572141627121"
  };
  firebase.initializeApp(config)


const app = <BrowserRouter><App /></BrowserRouter>

ReactDOM.render(app, document.getElementById('root'))
serviceWorker.unregister();
